<div class="tw-w-full">
  @if(this.appNotificationService.initialLoading()){

  <div class="tw-flex-center tw-my-20 tw-pb-[2px] tw-py-[1px] tw-w-full">
    <span
      class="spinner-border spinner-border-lg"
      role=" status"
      aria-hidden="true"
    ></span>
  </div>

  } @else {

  <div class="row">
    <nav
      ngbNav
      #nav="ngbNav"
      class="nav-tabs border-bottom tw-text-center tw-sticky tw-top-0 tw-z-[5] tw-bg-white dark:tw-bg-dark-300"
      [destroyOnHide]="false"
    >
      <!-- *unread messages file -->
      <ng-container [ngbNavItem]="'unreadMessages'">
        <a
          ngbNavLink
          class="tw-flex-center border bg-transparent"
          style="flex: 1"
        >
          <span class="tw-mt-1 tw-mr-2 text-dark">{{
            "common.unreadMessages" | translate
          }}</span>
          <span class="badge badge-light tw-mx-1">
            {{ appNotificationService.unreadNotificationsCount() }}
          </span>
        </a>
        <ng-template ngbNavContent>
          <div class="rtl:tw-pr-5 ltr:tw-pl-5">
            @for(item of appNotificationService.unreadNotifications(); track
            item.notificationId ) {
            <notification-item
              [notification]="item"
              (updateNotifications)="getNotificationListApi()"
            ></notification-item>
            } @empty{
            <div class="tw-w-full tw-my-20 tw-opacity-40">
              <h3 class="tw-text-center dark:tw-text-gray-300">
                {{ "common.empty" | translate }}
              </h3>
            </div>
            }
          </div>
        </ng-template>
      </ng-container>

      <!-- *all messages -->
      <ng-container [ngbNavItem]="'allMessages'">
        <a
          ngbNavLink
          class="tw-flex-center border bg-transparent"
          style="flex: 1"
        >
          <span class="tw-mt-1 tw-mr-2 text-dark">{{
            "common.allMessages" | translate
          }}</span>
          <span class="badge badge-light tw-mx-1">
            {{ appNotificationService.allNotificationsCount() }}
          </span>
        </a>

        <ng-template ngbNavContent>
          <div class="rtl:tw-pr-5 ltr:tw-pl-5">
            @for(item of appNotificationService.allNotifications(); track
            item.notificationId ) {
            <notification-item
              [notification]="item"
              (updateNotifications)="getNotificationListApi()"
            ></notification-item>
            } @empty{
            <div class="tw-w-full tw-my-20 tw-opacity-40">
              <h3 class="tw-text-center dark:tw-text-gray-300">
                {{ "common.empty" | translate }}
              </h3>
            </div>
            }
          </div>
        </ng-template>
      </ng-container>
    </nav>
    <div [ngbNavOutlet]="nav" class="tw-mt-2"></div>
  </div>
  }
</div>
